export default __webpack_public_path__ + "a3196e840709b18a3119789ce6291ae1.svg";